export default __webpack_public_path__ + "static/media/No.8-1.d82700a9.jpg";